import React from 'react';
import {info_Green} from '../../../assets/images/images';

export const UserData = () => (
  <>
    <header className="flex flex-col items-center mt-2">
      <div className="flex items-center gap-2 p-2 mt-4 bg-[#E2F5F6] rounded-full">
        <img src={info_Green} alt="" width={20} height={20} className="" />
        <p className="text-sm rounded-lg text-[#4A878D] font-medium  ">
          Fill the form as it appears on your valid ID
        </p>
      </div>
    </header>
    <form className="w-full max-w-sm mt-[30px] space-y-4 px-6">
      <label
        htmlFor="first_name"
        className="mb-1 text-[#1B2A4E] text-sm font-normal"
      >
        First name
        <input
          disabled
          type="text"
          id="first_name"
          placeholder="First name"
          className="bg-[#F9F9F9] mt-2 text-[#8D8D91] text-sm rounded"
        />
      </label>
      <label
        htmlFor="last_name"
        className="mb-1 text-[#1B2A4E] text-sm font-normal"
      >
        Last name
        <input
          disabled
          type="text"
          id="last_name"
          placeholder="Last name"
          className="bg-[#F9F9F9] mt-2 text-[#8D8D91] text-sm rounded"
        />
      </label>
      <label
        htmlFor="middle_name"
        className="mb-1 text-[#1B2A4E] text-sm font-normal"
      >
        Middle name
        <input
          disabled
          type="text"
          id="middle_name"
          placeholder="Middle name"
          className="bg-[#F9F9F9] mt-2 text-[#8D8D91] text-sm rounded"
        />
      </label>

      <label htmlFor="dob" className="mb-1 text-[#1B2A4E] text-sm font-normal">
        Date of birth
        <input
          disabled
          type="date"
          id="dob"
          className="bg-[#F9F9F9] mt-2 text-[#8D8D91] text-sm rounded"
        />
      </label>
    </form>
  </>
);
